import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

/**
 * The purpose of this intercept is to track the status of http requests for the purposes of showing/hiding a loader
 * Refer this https://firstclassjs.com/display-a-loader-on-every-http-request-using-interceptor-in-angular-7.
 */

@Injectable({
  providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
  // counter for total request
  requestCounter = 0;

  constructor(public loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requestCounter += 1;

    // show loader on  request being initialized
    this.loaderService.show();

    return next.handle(req).pipe(
      finalize(() => {
        // minus counter after request finalize
        this.requestCounter -= 1;

        // check if no request pending and hide loader
        if (this.requestCounter === 0) {
          this.loaderService.hide();
        }
      }),
    );
  }
}
